import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { withLayout } from "../hoc/with-layout";
import { useQueryClient } from "@tanstack/react-query";
import { ProductMarketingForm } from "../components/ProductMarketingForm";
import { useContext, useMemo } from "react";
import { RoleContext } from "../role-provider";

export const CreateProduct = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { defaultLanguage } = useContext(RoleContext);

  const onSaveSuccess = () => {
    queryClient.invalidateQueries(["getProductsList"]);
    queryClient.invalidateQueries(["getAllProductsList"]);
    navigate(`/products`);
  };

  const CreateProductWithLayout = useMemo(() => {
    return withLayout(() => {
      return (
        <StyledRelativeContainer>
          <Box sx={{ flexGrow: 1, px: 0 }}>
            <Grid container>
              <Grid container mobile={9} sx={{ alignItems: "center", mb: 4 }}>
                <Grid>
                  <Typography variant="h2">New Product</Typography>
                </Grid>
              </Grid>

              <Grid mobile={12}>
                <ProductMarketingForm
                  editable={true}
                  isLive={false}
                  saveSuccessMessage="Product was created successfully"
                  language={
                    typeof defaultLanguage === "string" ? defaultLanguage : "EN"
                  }
                  setLanguage={() => {}}
                  onSaveSuccess={onSaveSuccess}
                />
              </Grid>
            </Grid>
          </Box>
        </StyledRelativeContainer>
      );
    }, "New Product");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLanguage]);

  return <CreateProductWithLayout />;
};

const StyledRelativeContainer = styled(Grid)({
  margin: 0,
  position: "relative",
});
